import React, { useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { setCurrentActivity } from 'features/maincon/activity/actions'
import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'
import { EventModal } from 'Components/Shared'
import Menu from 'Components/MenuAdmin/AdminQCMenu'

import Breadcrumbs from './Breadcrumbs'
import styled from 'styled-components'
import { getReportDetail } from 'features/adminReport/constructPlan/api'
import { GetReportDetailReq } from 'features/adminReport/constructPlan/types'
import { toNumber } from 'lodash'
import ReportDetail from './ReportDetail'
import {
  selectEvent,
  selectReportDetail,
} from 'features/adminReport/constructPlan/selector'

type FormProps = {
  id: string
}

type Props = FormProps &
  RouteComponentProps<{
    projectCode: string
    checkNo: string
    requestID: string
  }> &
  ReduxProps

const ReportDetailPage = (props: Props) => {
  const [lastPage, setLastPage] = useState('')

  const [enable, setEnable] = useState(false)
  const { Token, UserEmail, match, data, event } = props

  const CheckNumber = match.params.checkNo
  const ProjectCode = match.params.projectCode
  const RequestID = match.params.requestID
  const onPageClose = () => {
    if (lastPage !== '') {
      setLastPage('')
    }
  }

  const dispatch = useDispatch()

  useEffect(() => {
    setEnable(false)
  }, [data])

  useEffect(() => {
    onGetActivityDetail()
  }, [UserEmail, ProjectCode, Token, dispatch])

  const onGetActivityDetail = () => {
    setEnable(true)
    const data: GetReportDetailReq = {
      ProjectCode,
      UserEmail,
      CheckNumber: toNumber(CheckNumber),
      RequestID: toNumber(RequestID),
    }
    dispatch(getReportDetail(Token, data))
  }

  const onSuccess = () => {
    setEnable(false)
    onGetActivityDetail()
  }

  return (
    <>
      <EventModal
        name="activity"
        event={[event]}
        enable={enable}
        successCalback={onSuccess}
      />
      <Breadcrumbs activity={data} onClose={onPageClose} />
      <Menu selected={'report.site'}>
        <ReportDetail data={data} />
      </Menu>
    </>
  )
}

const Title = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 28px;
  color: #000;
`

const mapStateToProps = (state: RootState) => {
  return {
    UserEmail: userEmailSelector(state),
    Token: serviceTokenSelector(state),
    data: selectReportDetail(state),
    event: selectEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {
  setCurrentActivity,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetailPage)
